@if (profileField$ | async; as profileField) {
  <med-form-permissions
    [id]="profileField.FieldDefinition.FlatKey"
    [control]="control$ | async"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [helpText]="profileField.Description"
    [canBeIndeterminate]="canBeIndeterminate"
    [indeterminateMsg]="'general.different-values' | translate"
    [readLabel]="'modules.general.form.rights.permissions.ReadRights' | translate"
    [writeLabel]="'modules.general.form.rights.permissions.WriteRights' | translate"
    [exportLabel]="'modules.general.form.rights.permissions.ExportRights' | translate"
    [noneSelectedMsg]="'general.filter.noneSelected' | translate"
    [multipleSelectedMsg]="'general.filter.multipleSelected' | translate"
    [allSelectedMsg]="'general.filter.allSelected' | translate"
    [isBatchEdit]="isBatchEdit"
    >
    <ng-content></ng-content>
  </med-form-permissions>
}
